module.exports = __webpack_public_path__ + "img/sin-foto.723caec7.png";